export enum Level {
    ANJO = '5a28815a-b348-4790-ae9f-9e0ab3407252',
    AGENTE = '43372f78-6245-4a10-aa35-8a4c7bac0d03',
}

export class Agent {

    public id?: string;
    public name: string;
    public city?: string;
    public level?: string;
    public state?: string;
    public userId?: string;
    public gender?: string;
    public birthDate?: Date;
    public phoneNumber: string;
    public neighbourhood?: string;
	public address?: any;
	public complementAddress?: string;
	public addressNumber?: string;
	public moduleId?: string;
	public zipCode?: string;
	public cpf?: string;
	public whatsApp?: string;
	public email?: string;
    public acceptContractTerms?: boolean;
    public contextId?: string;
    public context?: { id: string; context: string; profile?: any };
    /** Nome da Rede Dedicada à qual o agente está vinculado (hoje só 1 por agente). */
    public dedicatedCompanyName?: string;
    public invite?: any; // TODO: Ver onde é chamado
    public birthDateInput?: any;
    public profileImageUrl?: string;
    public pendingProfileImage?: boolean;
    public profileImageStatus?: 'APPROVED' | 'PENDING' | 'REVIEW' | 'REJECTED';
    public profileImageRejectionReason?: string;

    public static isLevelAnjo(level: string): boolean {
        return Level.ANJO === level;
    }
}
